export const appConfig = {
  PAYWAY_GROUPS_ORDER_CONFIG: null,
  CARD_IFRAME_URL: null,
}

export const setAppConfig = (key, value) => {
  if (key in appConfig) {
    appConfig[key] = value
  }
}

export const getAppConfig = (key, defaultValue = null) => {
  return appConfig[key] !== null ? appConfig[key] : defaultValue
}
